import { cn } from "@/lib/cn";

/**
 * Segmented control de janela de tempo (7d / 30d / 90d). Filtragem é
 * client-side: a view busca 90 dias uma vez e só re-renderiza ao trocar.
 */

export type WindowKey = "7d" | "30d" | "90d";

export const WINDOW_OPTIONS: ReadonlyArray<{ key: WindowKey; label: string; days: number }> = [
  { key: "7d", label: "7 dias", days: 7 },
  { key: "30d", label: "30 dias", days: 30 },
  { key: "90d", label: "90 dias", days: 90 },
] as const;

export function windowDays(key: WindowKey): number {
  return WINDOW_OPTIONS.find((o) => o.key === key)?.days ?? 90;
}

interface WindowFilterProps {
  value: WindowKey;
  onChange: (key: WindowKey) => void;
}

export function WindowFilter({ value, onChange }: WindowFilterProps) {
  return (
    <div
      role="tablist"
      aria-label="Filtrar período"
      className="inline-flex w-full items-center gap-1 rounded-full border border-border-subtle bg-surface p-1"
    >
      {WINDOW_OPTIONS.map((opt) => {
        const active = opt.key === value;
        return (
          <button
            key={opt.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(opt.key)}
            className={cn(
              "flex-1 rounded-full px-3 py-1.5 text-xs font-semibold transition-all",
              active
                ? "bg-accent text-ink"
                : "text-muted hover:text-ink",
            )}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
